export default "__VITE_ASSET__4rIOXSOl__"